import { render, staticRenderFns } from "./TranslationModalSingleChoice.vue?vue&type=template&id=75ad1dd7&scoped=true&"
import script from "./TranslationModalSingleChoice.vue?vue&type=script&lang=js&"
export * from "./TranslationModalSingleChoice.vue?vue&type=script&lang=js&"
import style0 from "./TranslationModalSingleChoice.vue?vue&type=style&index=0&id=75ad1dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ad1dd7",
  null
  
)

export default component.exports